import { render } from "./ClosingPeriodsOverview.vue?vue&type=template&id=72467285&scoped=true&ts=true"
import script from "./ClosingPeriodsOverview.vue?vue&type=script&lang=ts"
export * from "./ClosingPeriodsOverview.vue?vue&type=script&lang=ts"

import "./ClosingPeriodsOverview.vue?vue&type=style&index=0&id=72467285&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72467285"]])

export default __exports__